import { toast } from 'react-toastify';
import { postApiCall } from '../Handlers/HttpHandler';

/**
 * Fetches the list of active aggregators.
 */
export const getAggregators = async (token) => {
  try {
    const result = await postApiCall('aggregator-list', { values: { is_active: '1' } }, token);

    if (result.error) {
      toast.error(result.error?.message ?? result.error);
      return null;
    }

    return result.data ?? [];
  } catch (ex) {
    toast.error('Failed to load aggregators');
    return null;
  }
};
